var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1241_2751)",
    filter: "url(#filter0_d_1241_2751)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1241_2751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0908 15.4288L13.4738 15.0458L13.0908 15.4288L13.3291 15.6672L13.7121 16.0502L14.0952 15.6672L15.9585 13.8038C16.0611 13.7012 16.2382 13.7012 16.3408 13.8038C16.4434 13.9065 16.4434 14.0835 16.3408 14.1861L13.9033 16.6236L13.903 16.6239C13.8523 16.6747 13.7835 16.7033 13.7117 16.7033L13.7121 17.245V16.7033C13.6422 16.7033 13.5766 16.6792 13.521 16.6236L12.7085 15.8111C12.6059 15.7085 12.6059 15.5315 12.7085 15.4288C12.8111 15.3262 12.9882 15.3262 13.0908 15.4288ZM13.3291 23.2505L13.7121 23.6335L14.0952 23.2505L15.9585 21.3872C16.0611 21.2845 16.2382 21.2845 16.3408 21.3872C16.4434 21.4898 16.4434 21.6668 16.3408 21.7695L13.9033 24.207L13.903 24.2072C13.8524 24.2579 13.7838 24.2865 13.7121 24.2866C13.6422 24.2866 13.5765 24.2625 13.521 24.207L13.138 24.59L13.521 24.207L12.7085 23.3945C12.6059 23.2918 12.6059 23.1148 12.7085 23.0122C12.8111 22.9095 12.9882 22.9095 13.0908 23.0122L13.3291 23.2505ZM25.0871 15.88H19.3996C19.2546 15.88 19.1288 15.7542 19.1288 15.6091C19.1288 15.4641 19.2546 15.3383 19.3996 15.3383H25.0871C25.159 15.3383 25.2279 15.3668 25.2786 15.4176C25.3294 15.4684 25.358 15.5373 25.358 15.6091C25.358 15.681 25.3294 15.7499 25.2786 15.8007C25.2279 15.8514 25.159 15.88 25.0871 15.88ZM25.0871 23.4633H19.3996C19.2546 23.4633 19.1288 23.3375 19.1288 23.1925C19.1288 23.0475 19.2546 22.9216 19.3996 22.9216H25.0871C25.159 22.9216 25.2279 22.9502 25.2786 23.001C25.3294 23.0518 25.358 23.1207 25.358 23.1925C25.358 23.2643 25.3294 23.3332 25.2786 23.384C25.2278 23.4348 25.159 23.4633 25.0871 23.4633Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 1.08333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2493 30.6458H15.7493C9.86685 30.6458 7.35352 28.1325 7.35352 22.25V15.75C7.35352 9.8675 9.86685 7.35416 15.7493 7.35416H22.2493C28.1318 7.35416 30.6452 9.8675 30.6452 15.75V22.25C30.6452 28.1325 28.1318 30.6458 22.2493 30.6458ZM15.7493 8.97916C10.7552 8.97916 8.97852 10.7558 8.97852 15.75V22.25C8.97852 27.2442 10.7552 29.0208 15.7493 29.0208H22.2493C27.2435 29.0208 29.0202 27.2442 29.0202 22.25V15.75C29.0202 10.7558 27.2435 8.97916 22.2493 8.97916H15.7493Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1241_2751",
    x: 2,
    y: 3,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_2751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1241_2751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1241_2751",
    x: 3.35352,
    y: 4.35416,
    width: 31.291,
    height: 31.2917,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_2751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1241_2751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1241_2751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.d2a78af0e8791a47dbd52eb551bff4e6.svg";
export { ForwardRef as ReactComponent };